import React, { Children, type PropsWithChildren } from 'react';
import { StyleSheet, View, type ViewProps } from 'react-native';

import { theme } from '@garnish/constants';

// ─────────────────────────────────────────────────────────────────────────────

export const ProductCardV2Footer = (props: Props) => {
  const { children, style } = props;

  // Prevent rendering if no children are provided
  if (Children.count(children) === 0) {
    return null;
  }

  return <View style={[styles.container, style]}>{children}</View>;
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  container: {
    width: '100%',
    gap: theme.spacing['1'],
    marginTop: 'auto', // push to the bottom of the card
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type Props = PropsWithChildren<{
  style?: ViewProps['style'];
}>;
